import { Box } from '@mui/material'
import React from 'react'

const Dashboard = () => {
  return (
    <Box>Dashboard</Box>
  )
}

export default Dashboard